/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddMenuSubcategoryDto as DigiworkMaitreDPosDtoMenuSubcategoriesAddMenuSubcategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/add-menu-subcategory-dto';
import { MenuSubcategoryDto as DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategory-dto';

export interface AddMenuSubcategory$Params {
  menuCategoryId: string;
      body?: DigiworkMaitreDPosDtoMenuSubcategoriesAddMenuSubcategoryDto
}

export function addMenuSubcategory(http: HttpClient, rootUrl: string, params: AddMenuSubcategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>> {
  const rb = new RequestBuilder(rootUrl, addMenuSubcategory.PATH, 'post');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>;
    })
  );
}

addMenuSubcategory.PATH = '/api/menu-categories/{menuCategoryId}/menu-subcategories';
